import { useTranslation } from 'react-i18next'
import React, { useMemo } from 'react'
import { ReactComponent as NoClientsImage } from 'images/illustration/no-clients.svg'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Grid, Typography } from 'gu-ui-kit'
import styles from 'components/EmptyResults/EmptyResults.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const EmptyResults = ({
  header = '',
  text = '',
  className = '',
  image = <NoClientsImage className={styles['empty-results__image']} />,
  icon = null,
  actionButton = null,
}) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation()

  const emptyIconProps = useMemo(() => {
    const size = breakpoints.sm ? 48 : breakpoints.fb ? 72 : 96

    return {
      width: size,
      height: size,
    }
  }, [breakpoints])

  const fonts = useMemo(() => {
    switch (true) {
      case breakpoints.sm:
        return {
          header: 'Header-30',
          title: 'Body-15',
        }
      case breakpoints.md:
        return {
          header: 'Header-40',
          title: 'Body-20',
        }
      default:
        return {
          header: 'Header-50',
          title: 'Body-25',
        }
    }
  }, [breakpoints])

  return (
    <Grid
      alignItems={'center'}
      direction={'column'}
      className={clsx(styles['empty-results'], className)}
    >
      {icon ? (
        <Grid
          alignItems={'center'}
          justifyContent={'center'}
          className={styles['empty-results__icon']}
        >
          {icon}
        </Grid>
      ) : (
        React.cloneElement(image, emptyIconProps)
      )}
      <Typography
        className={clsx('margin-top-32', 'margin-bottom-16', 'margin-left-16', 'margin-right-16')}
        variant={fonts.header}
        color={'Label-Primary'}
      >
        {header || t('common::empty_results.header')}
      </Typography>
      <Typography variant={fonts.title} color={'Label-Fifth'} noMargin>
        {text || t('common::empty_results.text')}
      </Typography>
      {actionButton && (
        <Grid justifyContent={'center'} className={'margin-top-32'}>
          {actionButton}
        </Grid>
      )}
    </Grid>
  )
}

EmptyResults.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  image: PropTypes.element,
  icon: PropTypes.element,
  actionButton: PropTypes.oneOfType([PropTypes.element, PropTypes.oneOf([null])]),
}

export default EmptyResults
